import Vue from 'vue';

import { sdsTooltipDirective } from '@shared/components/tooltip/SdsTooltipDirective';

export const tooltip = Vue.directive('tooltip', sdsTooltipDirective);
